import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function FinalCTA() {
  return <section id="cta-final" className="py-16 px-4 relative overflow-hidden" style={{
    background: 'linear-gradient(135deg, #3b0a1a 0%, #5c1a2a 30%, #3b0a1a 60%, #2a0715 100%)'
  }} data-id="element-50">
      {/* Decorative glows */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-gold-300/20 rounded-full blur-3xl" data-id="element-51"></div>
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-dusty-rose-400/15 rounded-full blur-3xl" data-id="element-52"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-300/5 rounded-full blur-3xl" data-id="element-53"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-54">
        <FadeIn data-id="element-55">
          {/* Card container */}
          <div className="bg-white/10 backdrop-blur-sm border border-gold-300/30 rounded-3xl p-8 md:p-12 shadow-2xl text-center" data-id="element-56">
            {/* Sparkle accent */}
            <motion.div animate={{
            opacity: [0.5, 1, 0.5]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="text-4xl mb-4" data-id="element-57">
              ✨
            </motion.div>

            <h2 className="text-3xl md:text-5xl font-bold text-gold-300 mb-6 leading-tight drop-shadow-lg" data-id="element-58">
              Estás a un clic de entender a tu hijo de verdad
            </h2>

            <p className="text-xl text-cream-100 mb-4" data-id="element-59">
              Por{' '}
              <span className="font-bold text-gold-300 text-2xl" data-id="element-60">$11 USD</span>{' '}
              recibís los 6 tomos completos más los 3 bonus exclusivos.
            </p>
            <p className="text-sm text-cream-200/80 mb-10" data-id="element-61">
              Descarga inmediata · Acceso de por vida · Sin suscripciones
            </p>

            {/* Pulsing CTA button */}
            <div className="relative inline-block w-full md:w-auto" data-id="element-62">
              {/* Glow behind button */}
              <motion.div animate={{
              scale: [1, 1.05, 1],
              opacity: [0.4, 0.7, 0.4]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute inset-0 bg-gold-300/40 rounded-full blur-xl" data-id="element-63"></motion.div>

              <motion.a href="https://pay.hotmart.com/S104936734A?checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="relative inline-flex flex-col items-center bg-gradient-to-r from-gold-300 via-gold-200 to-gold-300 text-burgundy-900 font-bold py-3 px-10 rounded-full shadow-2xl hover:shadow-[0_0_40px_rgba(212,175,55,0.5)] transition-all w-full md:w-auto border border-gold-400/50 text-center" data-id="element-64">
                <span className="text-sm md:text-base tracking-wide" data-id="element-65">
                  🌟 SÍ QUIERO MI COLECCIÓN COMPLETA — $11 USD
                </span>
                <span className="text-[9px] font-normal mt-1 opacity-80" data-id="element-66">
                  💱 Pagarás en la moneda de tu país
                </span>
              </motion.a>
            </div>

            {/* Trust badges */}
            <div className="flex items-center justify-center gap-1.5 text-[10px] font-medium text-cream-200/70 mt-5" data-id="element-67">
              <span data-id="element-68">🔒 Pago seguro</span>
              <span className="text-gold-300/40" data-id="element-69">·</span>
              <span data-id="element-70">⚡ Descarga inmediata</span>
              <span className="text-gold-300/40" data-id="element-71">·</span>
              <span data-id="element-72">🛡️ Garantía de 7 días</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}